import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { Header } from '@/components/Settings/DataExtraction/ExtractionType/Hierarchy/Steps/Header';
import { DetailedData } from './DetailedData';
import { useDataExtractionReport } from '@/context/DataExtractionReport';
import { StepsContainer } from '../../styles';

export function GeneralInformationSummary() {
	const { gutterLayout } = useDataExtractionReport();

	return (
		<StepsContainer>
			<Row gutter={gutterLayout} justify="space-between">
				<Col span={24}>
					<Header title={I18n.get('General Information')} />
				</Col>
				<Col span={24}>
					<DetailedData />
				</Col>
			</Row>
		</StepsContainer>
	);
}
